import {useState, Dispatch, SetStateAction} from 'react'

type UseOpen = (
  initialOpen?: boolean
) => [boolean, () => void, () => void, Dispatch<SetStateAction<boolean>>]

const useOpen: UseOpen = (initialOpen = false) => {
  const [isOpen, setIsOpen] = useState<boolean>(initialOpen)

  const handleOpen = () => setIsOpen(true)

  const handleClose = () => setIsOpen(false)

  return [isOpen, handleOpen, handleClose, setIsOpen]
}

export default useOpen
